import { applyMiddleware, createStore } from 'redux';
import { combineReducers } from 'redux-immutable';
import reduxThunk from 'redux-thunk';

import userDataReducer from 'app/reducer/UserData';

const reducers = combineReducers({
  userData: userDataReducer,
});

export default () => {
  const createStoreWithMiddleware = applyMiddleware(reduxThunk)(createStore);
  const store = createStoreWithMiddleware(reducers);

  return store;
};
